import { AssetTransaction } from '../types/asset_transaction/assetTransaction';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/asset_transaction/list';

const VERIFY = '/api/asset_transaction/ownership/verify';
const CONFIRM = '/api/asset_transaction/ownership/confirm';
const REJECT = '/api/asset_transaction/ownership/reject';

export namespace AssetTransactionRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<AssetTransaction>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const verify = async (payload: { assetId: string }): Promise<AssetTransaction[]> => {
    return (await http.post(VERIFY, payload)).data;
  };

  export const confirm = async (payload: { data: AssetTransaction[] }): Promise<AssetTransaction[]> => {
    return (await http.post(CONFIRM, payload)).data;
  };

  export const reject = async (payload: { assetId: string }): Promise<AssetTransaction[]> => {
    return (await http.post(REJECT, payload)).data;
  };
}
